const buildConfig = (keyword, ext = {}) => {
  return {
    label: keyword, // 需要提示的关键字
    kind: 18, // 对应monaco.languages.CompletionItemKind.Text
    insertText: `${keyword}`, // 确认后输入的内容
    ...ext
  }
}

/**
 * 官方日期内建函数
 * 数据来源：http://freemarker.foofun.cn/ref_builtins_date.html
 * @author Caesar Liu
 * @date 2020-11-20 14:58
 */
module.exports = [
  // 全部丢弃
]
